import React, {Component} from 'react'

export default class ConfirmBtn extends Component {
    render(){
        return ( 
            <button className={this.props.isConfirm ? "confirm-btn active" : "confirm-btn"} 
                        onClick={()=>this.props.onClick()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14.232" height="10.611" viewBox="0 0 14.232 10.611">
                    <path id="패스_4" data-name="패스 4" d="M9325.263-1202.627l4.259,4.162,5.741-7" transform="translate(-9323.142 1207.576)" fill="none" stroke="#999" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                </svg>
                Confirm & move next
            </button>
        )
    }
}